<template>
    <div class="modal" v-if="showModal">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Fila de Mensagens</h5>
                <button type="button" class="close" @click="closeModal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <vuedraggable 
                    v-model="msgsQueue"
                    v-bind="dragOptions"
                    @start="drag = true"
                    @end="drag = false" 
                    handle=".handler-container"
                >
                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                        <div v-for="(item, index) in msgsQueue" :key="`${index}-${JSON.parse(item).msg}`" class="msg-item" role="alert">
                            <div class="col-1 handler-container" title="Mover mensagem">
                                <i class="handle fas fa-arrows-alt"></i>
                            </div>
                            <div class="col-10 m-1">
                                <div class="row">
                                    <div v-if="JSON.parse(item).file" class="image-preview" v-html="JSON.parse(item).msg"></div>
                                    <div v-else v-html="formatMessage(JSON.parse(item).msg)"></div>
                                </div>
                                <div class="row time-stamp">
                                    <span >{{ JSON.parse(item).date }}</span>
                                </div>
                            </div>
                            <div class="col action-buttons-container" @click="msgsQueue.splice(index, 1)" title="Apagar mensagem">
                                <button type="button" class="delete-msg-button">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </transition-group>
                </vuedraggable>
            </div>
            <div class="modal-footer">
                <button type="button" class="close-modal" @click="closeModal"><i class="fas fa-times"></i>      Cancelar edição</button>
                <button type="button" class="update-queue" @click="updateQueue"><i class="fas fa-save"></i>      Salvar alterações</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MsgsQueueModal",
        props: {
            msgs: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                msgsQueue: [],
                showModal: true,
                drag: false
            }
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            }
        },
        methods: {
            closeModal() {
                this.showModal = false;
                this.$emit('close-modal');
            },
            updateQueue() {
                this.showModal = false;
                this.$emit('update-msgs-queue', this.msgsQueue);
            },
            formatMessage(msg) {
                const result_asterisco = this.formatTextWpp(msg);

                return result_asterisco.replaceAll('\n', '<br/>');
            },
            formatTextWpp(text){
                return text.replace(/(?:\*)(?:(?!\s))((?:(?!\*|\n).)+)(?:\*)/g,'<span style="font-weight: bold;">$1</span>')
                            .replace(/(?:_)(?:(?!\s))((?:(?!\n|_).)+)(?:_)/g,'<span style="font-style: italic;">$1</span>')
                            .replace(/(?:~)(?:(?!\s))((?:(?!\n|~).)+)(?:~)/g,'<span style="text-decoration: line-through;">$1</span>')
                            .replace(/(?:--)(?:(?!\s))((?:(?!\n|--).)+)(?:--)/g,'<span style="text-decoration: underline;">$1</span>')
                            .replace(/(?:```)(?:(?!\s))((?:(?!\n|```).)+)(?:```)/g,'<span style="font-family:\'Lucida Console\', monospace">$1</span>');
            },
        },
        mounted() {
            this.msgsQueue = this.msgs;
        },
        watch: {
            msgs: {
                handler: function (newVal, oldVal) {
                    this.msgsQueue = newVal;
                    console.log('msgsQueue', this.msgsQueue)
                },
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal {
        display: flex;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1050;
        width: 100%;
        height: 100%;
        overflow: hidden;
        outline: 0;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.5);

        .modal-content {
            position: relative;
            display: flex;
            flex-direction: column;
            width: 60%;
            max-height: 70%;
            min-height: 70%;
            pointer-events: auto;
            background-color: #fff;
            background-clip: padding-box;
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-radius: 0.3rem;
            outline: 0;

            .modal-header {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                padding: 15px;
                border-bottom: 1px solid #e9ecef;
                border-top-left-radius: 0.3rem;
                border-top-right-radius: 0.3rem;

                .modal-title {
                    margin-bottom: 0;
                    line-height: 1.5;
                }

                .close {
                    padding: 15px;
                    margin: -15px -15px -15px auto;
                    background-color: transparent;
                    border: 0;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    appearance: none;
                }
            }

            .modal-body {
                position: relative;
                flex: 1 1 auto;
                padding: 15px;
                max-height: 60%;
                overflow: auto;
                
                .msg-item {
                    display: flex;
                    gap: 10px;
                    color: black;
                    margin-bottom: 10px;
                    box-shadow: 1px 1px 4px 1px gray;
                    border: 1px solid gray;
                    border-radius: 5px;
                    background-color: lightgray;

                    .handler-container {
                        display: flex;
                        justify-content: center;
                        padding: 0;
                        align-items: center;
                        background-color: #8080804f;
                        border-right: 1px solid gray;
                        border-radius: 3px;
                        transition: 0.3s;
                        cursor: move;

                        &:hover {
                            .handle {
                                transform: scale(1.1);
                                color: black;
                            }
                        }

                        .handle {
                            text-align: center;
                            font-size: large;
                            width: 100%;
                            color: gray;
                            transition: 0.3s;
                        }
                    }

                    .time-stamp {
                        width: 100%;
                        justify-content: flex-end;
                        span {
                            font-size: 0.7rem;
                            font-weight: bold;
                            font-style: italic;
                            color: gray;
                        }
                    }

                    .action-buttons-container {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        gap: 5px;
                        padding: 0;
                        background-color: var(--danger);
                        border-left: 1px solid gray;
                        border-radius: 3px;
                        transition: 0.3s;
                        cursor: pointer;

                        &:hover {
                            background-color: #b52824;

                            .delete-msg-button {
                                transform: scale(1.1);
                            }
                        }

                        .delete-msg-button {
                            color: white;
                        }

                        button {
                            padding: 5px;
                            border: 0;
                            background-color: transparent;
                            cursor: pointer;
                            transition: 0.3s;

                            &:focus {
                                outline:0;
                            }
                        }
                    }
                }
            }

            .modal-footer {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding: 15px;
                border-top: 1px solid #e9ecef;
                border-bottom-right-radius: 0.3rem;
                border-bottom-left-radius: 0.3rem;

                .update-queue {
                    padding: 2px 10px;
                    font-weight: 600;
                    color: white;
                    background-color: #007bff;
                    border: 1px solid #007bff;
                    border-radius: 5px !important;
                    cursor: pointer;
                    transition: 0.3s;

                    &:hover {
                        background-color: #0056b3;
                        border: 1px solid #0056b3;
                    }
                }

                .close-modal {
                    padding: 2px 10px;
                    font-weight: 600;
                    color: white;
                    background-color: #dc3545;
                    border: 1px solid #dc3545;
                    border-radius: 5px !important;
                    cursor: pointer;
                    transition: 0.3s;

                    &:hover {
                        background-color: #c82333;
                        border: 1px solid #c82333;
                    }
                }
            }
        }
    }

    .image-preview {
        width: 40%;
        img {
            width: 40%;
            height: auto;
        }
    }

    .image-preview :deep(img) {
	    width: -webkit-fill-available;
    }
</style>
